export default "__VITE_ASSET__8c6871e5__"